import { useMemo } from 'react';

import {
   GynecologicalInterview,
   PatientPregnant,
   PregnancyCompletion,
   RegularInterview,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { MedicalInformationModal } from '../../MedicalInformationModal/MedicalInformationModal';

import { GynecologicalInterviewPatientPregnantInterview } from './GynecologicalInterviewPatientPregnantInterview';
import { GynecologicalInterviewPregnancyCompletionInterview } from './GynecologicalInterviewPregnancyCompletionInterview';

type MedicalInformationModalProps = {
   readonly gynecologicalInterview: GynecologicalInterview;
   readonly onClose: VoidFunction;
   readonly onMedicalDataAccessAuthorizationUpdate?: VoidFunction;
};

export const isPatientPregnantInterview = (
   gynecologicalInterview: GynecologicalInterview
): gynecologicalInterview is PatientPregnant =>
   gynecologicalInterview.class === 'egabinet-patient-medical-information-frontend-api:PatientPregnant';
export const isPregnancyCompletionInterview = (
   gynecologicalInterview: GynecologicalInterview
): gynecologicalInterview is PregnancyCompletion =>
   gynecologicalInterview.class === 'egabinet-patient-medical-information-frontend-api:PregnancyCompletion';
export const isRegularGynecologicalInterview = (
   gynecologicalInterview: GynecologicalInterview
): gynecologicalInterview is RegularInterview =>
   gynecologicalInterview.class === 'egabinet-patient-medical-information-frontend-api:RegularInterview';

export const GynecologicalInterviewModal = (props: MedicalInformationModalProps): JSX.Element => {
   const medicalInformation: GynecologicalInterview & { type: 'GYNECOLOGICAL_INTERVIEW' } = useMemo(
      () => ({ ...props.gynecologicalInterview, type: 'GYNECOLOGICAL_INTERVIEW' }),
      [props.gynecologicalInterview]
   );
   return (
      <MedicalInformationModal
         medicalInformation={medicalInformation}
         onClose={props.onClose}
         onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
      >
         <>
            {isPatientPregnantInterview(props.gynecologicalInterview) ? (
               <GynecologicalInterviewPatientPregnantInterview
                  patientPregnantInterview={props.gynecologicalInterview}
               />
            ) : null}
            {isPregnancyCompletionInterview(props.gynecologicalInterview) ? (
               <GynecologicalInterviewPregnancyCompletionInterview
                  completionDate={props.gynecologicalInterview.completionDate}
                  completionType={props.gynecologicalInterview.pregnancyCompletionType}
               />
            ) : null}
         </>
      </MedicalInformationModal>
   );
};
